import React, { useEffect, useState } from "react";
import axios from "../../../api/axios.js";
import {
  convertIntoSelect2Options,
  customConvertIntoSelect2OptionsClasses,
  getFetchOptions,
  uploadImage,
} from "../../../js/utility.js";
import Breadcrumb from "../../utils/Breadcrumb.jsx";
import Select from "react-select";

const EditStudent = () => {
  const [studentData, setStudentData] = useState([]);
  const [schoolOption, setSchoolOption] = useState([]);
  const [classOption, setClassOption] = useState([]);

  const [latestPolicy, setLatestPolicy] = useState(null);
  const [policyStatus, setPolicyStatus] = useState(null);

  const [avatar, setAvatar] = useState(null);

  const breadcrumb = {
    current_section: "Studenti",
    sections: [
      { name: "Scuole", route_name: null, params: [] },
      { name: "Classi", route_name: null, params: [] },
      { name: "Studenti", route_name: null, params: [] },
      { name: "Modifica", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchSchools = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/scuola`,
          fetchOptions
        );
        const result = await response.json();
        setSchoolOption(
          convertIntoSelect2Options(result.return.scuola, "id", "denomistituto")
        );
      } catch (error) {
        console.error(error);
      }
    };

    const fetchStudentData = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${
            axios.defaults.baseBFFUrl
          }/fe/getStudent?studentId=${window.location.href.split("/").pop()}`,
          fetchOptions
        );
        const result = await response.json();
        setStudentData(result);
      } catch (error) {
        console.error(error);
      }
    };

    fetchSchools();
    fetchStudentData();
  }, []);

  useEffect(() => {
    const fetchStudentPolicyStatus = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getStudentPolicyAcceptance?studentId=${studentData.id}`,
          fetchOptions
        );
        const result = await response.json();
        setPolicyStatus(result);
      } catch (error) {
        console.error(error);
      }
    };

    fetchStudentPolicyStatus();
  }, [studentData.id]);

  useEffect(() => {
    handleImportSchoolChange(studentData.idscuole);
  }, [studentData.idscuole]);

  // Funzione per validare il codice fiscale italiano
  const isValidCF = (cf) => {
    if (!cf) return false;
    const regex = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i;
    return regex.test(cf);
  };
  // Stato per gestire l'errore del codice fiscale
  const [cfError, setCfError] = useState("");
  const isValidEmail = (email) => {
    if (!email) return false;
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const [emailError, setEmailError] = useState("");
  // Modifica handleSave per controllare il codice fiscale
  const handleSaveWithCFCheck = async () => {
    let hasError = false;

    if (!isValidCF(studentData.codicefiscale)) {
      setCfError("Codice fiscale non valido");
      hasError = true;
    } else {
      setCfError("");
    }

    if (!isValidEmail(studentData.email)) {
      setEmailError("Email non valida");
      hasError = true;
    } else {
      setEmailError("");
    }

    if (!studentData.idscuole) {
      alert("Il campo Scuola è obbligatorio");
      hasError = true;
    }

    if (!studentData.idclasse) {
      alert("Il campo Classe è obbligatorio");
      hasError = true;
    }
    if (!studentData.nome) {
      alert("Il campo Nome è obbligatorio");
      hasError = true;
    }
    if (!studentData.cognome) {
      alert("Il campo Cognome è obbligatorio");
      hasError = true;
    }

    if (!studentData.birthdate) {
      alert("Il campo Data di Nascita è obbligatorio");
      hasError = true;
    }

    if (hasError) return;

    await handleSave();
  };

  const handlePolicyUpdate = (status) => {
    if (status === "accepted") {
      const updatePolicy = async () => {
        try {
          const fetchOptions = getFetchOptions(
            "application/x-www-form-urlencoded",
            [],
            "PUT"
          );
          const response = await fetch(
            `${axios.defaults.baseBFFUrl}/fe/acceptStudentPolicy?studentId=${studentData.id}`,
            fetchOptions
          );
          const result = await response.json();
          if (result.error) {
            alert("Error accepting policy");
            console.error("Error accepting policy", result.error);
          } else {
            window.location.reload();
          }
        } catch (error) {
          console.error("Error updating policy status", error);
        }
      };
      updatePolicy();
    }
  };

  const handleImportSchoolChange = (id) => {
    const fetchSchools = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/scuola/classi?idscuola=${studentData.idscuole}&annoscolastico=20242025`,
          fetchOptions
        );
        const result = await response.json();
        setClassOption(
          customConvertIntoSelect2OptionsClasses(
            result.return.classi,
            "idclassi",
            "classe",
            "sezione"
          )
        );
      } catch (error) {
        console.error(error);
      }
    };
    fetchSchools();
  };

  const handleSchoolChange = async (event) => {
    try {
      const fetchOptions = getFetchOptions(
        "application/x-www-form-urlencoded",
        [],
        "GET"
      );
      const response = await fetch(
        `${axios.defaults.baseURL}/scuola/classi?idscuola=${event?.value}&annoscolastico=20242025`,
        fetchOptions
      );
      const result = await response.json();
      setClassOption(
        customConvertIntoSelect2OptionsClasses(
          result.return.classi,
          "idclassi",
          "classe",
          "sezione"
        )
      );
      setStudentData({ ...studentData, idscuola: event?.value });
    } catch (error) {
      console.error(error);
    }
  };

  const handleClassChange = (event) => {
    setStudentData({ ...studentData, idclasse: event?.value });
  };

  const handleAvatarChange = () => {
    if (!avatar) {
      alert("Nessun file selezionato");
      console.error("No file selected");
      return;
    }

    const file = avatar;

    if (file) {
      uploadImage(file)
        .then(async (url) => {
          const fetchOptions = getFetchOptions(
            "application/json",
            { userId: studentData.id, link: url },
            "POST"
          );
          const response = await fetch(
            `${axios.defaults.baseBFFUrl}/app/profile/linkFirebaseAvatar`,
            fetchOptions
          );
          const result = await response.json();
          if (result.error) {
            alert(
              "Errore durante il caricamento dell'immagine del profilo. Riprova."
            );
            return;
          }

          alert("Immagine del profilo aggiornata con successo!");
          window.location.reload();
        })
        .catch((error) => {
          console.error("Error uploading image:", error);
        });
    }
  };

  const handleSave = async () => {
    const fetchOptions = getFetchOptions(
      "application/json",
      { studentId: studentData.id, studentData: studentData },
      "PUT"
    );
    const response = await fetch(
      `${axios.defaults.baseBFFUrl}/fe/updateStudent`,
      fetchOptions
    );
    const result = await response.json();

    if (result.error) {
      alert("Errore durante il salvataggio dei dati dello studente. Riprova.");
      console.error("Error saving student data", result.error);
      return;
    }

    window.location = `/students?schoolId=${studentData.idscuole}&classId=${studentData.idclasse}`;
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb */}
      <Breadcrumb breadcrumb={breadcrumb} />
      <a
        href={`/students?schoolId=${studentData.idscuole}&classId=${studentData.idclasse}`}
      >
        <button className="btn btn-primary mb-4">
          <i className="bi bi-arrow-left"></i> Torna alla lista studenti
        </button>
      </a>
      <br />
      <label className="mb-4">
        <b>(*) Campo obbligatorio</b>
      </label>

      <div className="card custom-card">
        <div className="card-header">Immagine del profilo</div>
        <div className="card-body">
          <div className="row row-cols-1 row-cols-lg-2 align-items-center">
            {studentData.image && (
              <span
                className="avatar mx-3 mb-3 mb-lg-0"
                style={{ backgroundImage: `url(${studentData.image})` }}
              ></span>
            )}
            <div className="col">
              <div className="input-group">
                <input
                  type="file"
                  className="form-control"
                  id="avatar"
                  aria-describedby="btnAvatar"
                  onChange={(e) => setAvatar(e.target.files[0])}
                  accept="image/*"
                />
                <button
                  className="btn btn-primary"
                  type="button"
                  id="btnAvatar"
                  onClick={handleAvatarChange}
                >
                  Carica
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Student Data Form */}
      <div className="card custom-card">
        <div className="card-header">Dati studente</div>
        <div className="card-body">
          <div className="row">
            <div className="col-12 col-lg-3">
              <label htmlFor="school">
                Scuola <b>*</b>
              </label>
              <Select
                options={schoolOption}
                id="school"
                name="school"
                value={schoolOption?.filter(function (option) {
                  return option.value === studentData.idscuole;
                })}
                onChange={handleSchoolChange}
                classNames={"form-control"}
                placeholder="Scegli scuola..."
                isSearchable
                isClearable
              />
            </div>

            <div className="col-12 col-lg-3">
              <label htmlFor="classe">
                Classe <b>*</b>
              </label>
              <Select
                options={classOption}
                id="classe"
                name="classe"
                value={classOption?.filter(function (option) {
                  return option.value === studentData.idclasse;
                })}
                onChange={handleClassChange}
                classNames={"form-control"}
                placeholder="Scegli classe..."
                isSearchable
                isClearable
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-4">
              <div className="form-group">
                <label htmlFor="name">
                  Nome <b>*</b>
                </label>
                <input
                  className="form-control"
                  id="nome"
                  name="nome"
                  value={studentData?.nome || ""}
                  onChange={(e) =>
                    setStudentData({ ...studentData, nome: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="col-12 col-lg-4">
              <div className="form-group">
                <label htmlFor="cognome">
                  Cognome <b>*</b>
                </label>
                <input
                  className="form-control"
                  id="cognome"
                  name="cognome"
                  value={studentData?.cognome || ""}
                  onChange={(e) =>
                    setStudentData({ ...studentData, cognome: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="col-12 col-lg-4">
              <div className="form-group">
                <label htmlFor="codicefiscale">
                  Codice Fiscale <b>*</b>
                </label>
                <input
                  className={`form-control ${cfError ? "is-invalid" : ""}`}
                  id="cf"
                  name="cf"
                  label="Codice fiscale"
                  value={studentData?.codicefiscale || ""}
                  onChange={(e) => {
                    setStudentData({
                      ...studentData,
                      codicefiscale: e.target.value,
                    });
                    if (cfError) setCfError("");
                  }}
                />
                {cfError && <div className="invalid-feedback">{cfError}</div>}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-4">
              <div className="form-group">
                <label htmlFor="birthDate">
                  Data di nascita <b>*</b>
                </label>
                <input
                  className="form-control"
                  type="date"
                  id="birthDate"
                  name="birthDate"
                  value={studentData?.birthdate || ""}
                  onChange={(e) =>
                    setStudentData({
                      ...studentData,
                      birthdate: e.target.value,
                    })
                  }
                />
              </div>
            </div>

            <div className="col-12 col-lg-4">
              <div className="form-group">
                <label htmlFor="email">
                  Email <b>*</b>
                </label>
                <input
                  className={`form-control ${emailError ? "is-invalid" : ""}`}
                  id="email"
                  name="email"
                  label="Email"
                  value={studentData?.email || ""}
                  onChange={(e) => {
                    setStudentData({ ...studentData, email: e.target.value });
                    if (emailError) setEmailError("");
                  }}
                />
                {emailError && (
                  <div className="invalid-feedback">{emailError}</div>
                )}
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="form-group">
                <label htmlFor="telefono">Telefono</label>
                <input
                  className="form-control"
                  id="telefono"
                  name="telefono"
                  type="number"
                  value={studentData?.telefono || ""}
                  onChange={(e) =>
                    setStudentData({
                      ...studentData,
                      telefono: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </div>

          {/* Save Button */}
          <div className="col-12">
            <div className="form-group">
              <div className="saveButtonContainer">
                <button
                  id="btnSave"
                  name="btnSave"
                  className="btn btn-success saveButton"
                  type="button"
                  onClick={handleSaveWithCFCheck}
                >
                  &nbsp;Salva
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Stato policy studente */}
      <div className="card custom-card">
        <div className="card-header">Gestione policy studente</div>
        <div className="card-body">
          <div className="row">
            <div className="col-4 d-flex align-items-center">
              <div>
                Stato policy:{" "}
                <span className="fw-bold">
                  {policyStatus
                    ? policyStatus.status === "OK"
                      ? "Accettate"
                      : "Non accettate"
                    : "Errore"}
                </span>
              </div>
            </div>
            <div className="col-4 d-flex align-items-center">
              <div className="d-flex flex-column">
                <a
                  href="https://cooltorial.it/privacy-e-note-legali/"
                  className="text-decoration-underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Visualizza policy per maggiorenni
                </a>
                <a
                  href="https://cooltorial.it/home/informativa-privacy/"
                  className="text-decoration-underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Visualizza policy per minorenni
                </a>
              </div>
            </div>
            <div className="col-4 d-flex align-items-center justify-content-end">
              <div>
                <button
                  id="btnPolicy"
                  name="btnPolicy"
                  className="btn btn-primary"
                  type="button"
                  onClick={() => handlePolicyUpdate("accepted")}
                >
                  Conferma accettazione
                </button>
                {/* <button
                  id="btnPolicy"
                  name="btnPolicy"
                  className="btn btn-danger"
                  type="button"
                  onClick={() => handlePolicyUpdate("rejected")}
                >
                  Rifiuta
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditStudent;
